import { render, staticRenderFns } from "./serviceTimeDepartment.vue?vue&type=template&id=5225648d"
import script from "./serviceTimeDepartment.vue?vue&type=script&lang=js"
export * from "./serviceTimeDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports